import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { MapAnnotationsState } from './mapAnnotations.types';
import {
  addMapAnnotation,
  deleteMapAnnotation,
  getMapAnnotations,
  updateMapAnnotation,
} from './mapAnnotations.thunks';

export const getMapAnnotationsReducer = (
  builder: ActionReducerMapBuilder<MapAnnotationsState>,
): void => {
  builder
    .addCase(getMapAnnotations.pending, (state, action) => {
      const { mapId } = action.meta.arg;
      state.loading[mapId] = 'pending';
      state.error = null;
    })
    .addCase(getMapAnnotations.fulfilled, (state, action) => {
      const { mapId, annotations } = action.payload;
      state.data[mapId] = annotations;
      state.loading[mapId] = 'succeeded';
    })
    .addCase(getMapAnnotations.rejected, (state, action) => {
      const { mapId } = action.meta.arg;
      state.loading[mapId] = 'failed';
      state.error = action.payload as { name: string; message: string };
    });
};

export const addMapAnnotationReducer = (
  builder: ActionReducerMapBuilder<MapAnnotationsState>,
): void => {
  builder
    .addCase(addMapAnnotation.pending, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'pending';
    })
    .addCase(addMapAnnotation.fulfilled, (state, action) => {
      const { mapId, annotation } = action.payload;
      state.data[mapId] = [...(state.data[mapId] ?? []), annotation];
      state.mutationLoading[mapId] = 'succeeded';
    })
    .addCase(addMapAnnotation.rejected, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'failed';
      state.error = action.payload as { name: string; message: string };
    });
};

export const updateMapAnnotationReducer = (
  builder: ActionReducerMapBuilder<MapAnnotationsState>,
): void => {
  builder
    .addCase(updateMapAnnotation.pending, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'pending';
    })
    .addCase(updateMapAnnotation.fulfilled, (state, action) => {
      const { mapId, annotation } = action.payload;
      const annotations = state.data[mapId] ?? [];
      const NOT_FOUND_INDEX = -1;
      const index = annotations.findIndex(existing => existing.id === annotation.id);
      if (index !== NOT_FOUND_INDEX) {
        annotations[index] = annotation;
      }
      state.data[mapId] = annotations;
      state.mutationLoading[mapId] = 'succeeded';
    })
    .addCase(updateMapAnnotation.rejected, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'failed';
      state.error = action.payload as { name: string; message: string };
    });
};

export const deleteMapAnnotationReducer = (
  builder: ActionReducerMapBuilder<MapAnnotationsState>,
): void => {
  builder
    .addCase(deleteMapAnnotation.pending, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'pending';
    })
    .addCase(deleteMapAnnotation.fulfilled, (state, action) => {
      const { mapId, annotationId } = action.payload;
      state.data[mapId] = (state.data[mapId] ?? []).filter(
        annotation => annotation.id !== annotationId,
      );
      state.mutationLoading[mapId] = 'succeeded';
    })
    .addCase(deleteMapAnnotation.rejected, (state, action) => {
      const { mapId } = action.meta.arg;
      state.mutationLoading[mapId] = 'failed';
      state.error = action.payload as { name: string; message: string };
    });
};
